import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import type { AppDispatch } from '../../../store/store';
import { Instrument } from '../../../types/instrument';

export const name = 'instrumentSearch';

export const initialState: Instrument[] = [];

const slice = createSlice({
	name: name,
	initialState,
	reducers: {
		resetData() {
			return initialState;
		},
		setInstruments: (_state, action) => {
			return action.payload;
		},
		addInstrument: (state, action) => {
			state.push(action.payload);
		},
		removeInstrument: (state, action) => {
			return state.filter(instrument => instrument.id !== action.payload.id);
		},
	},
});

export const { reducer, actions } = slice;

// reset
export const resetSelectedInstruments = () => actions.resetData();

export const selectInstrument = (selected: Instrument) => async (dispatch: AppDispatch) => {
	try {
		dispatch(actions.addInstrument(selected));
		return selected;
	} catch (err) {
		return null;
	}
};

export const removeInstrument = (instrument: Instrument) => async (dispatch: AppDispatch) => {
	try {
		dispatch(actions.removeInstrument(instrument));
		return true;
	} catch (err) {
		return false;
	}
};

export default slice;
